import { render } from "./ExpandButton.vue?vue&type=template&id=467bbe00"
import script from "./ExpandButton.vue?vue&type=script&lang=js"
export * from "./ExpandButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__